import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./../Styles/Viewmachines.css";
import { API, UPLOADS } from "./../../config/api";
import { useLocation } from "react-router-dom";
export default function ViewMachine() {
  const [machines, setMachines] = useState([]);
  const [viewData, setViewData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user?.id) {
      fetchMachines();
    }
  }, [location]);

  const fetchMachines = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));

      if (!user?.id) {
        console.error("No User ID found");
        return;
      }

      const res = await fetch(`${API.LIST_MACHINES}&user_id=${user.id}`);

      const data = await res.json();
      setMachines(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  const deleteMachine = async (id) => {
    if (!window.confirm("Delete this machine?")) return;

    try {
      const res = await fetch(`${API.DELETE_MACHINE}&id=${id}`);

      const data = await res.json();
      alert(data.message);
      fetchMachines();
    } catch (error) {
      console.error("Delete Error:", error);
      alert("Error deleting machine");
    }
  };

  return (
    <div className="dashboard-content">
      <h2>Manage Your Machines</h2>

      {/* CARD GRID */}
      <div className="product-grid">
        {machines.length > 0 ? (
          machines.map((item) => {
            const images = item.image
              ? item.image.split(",").filter((img) => img && img.trim() !== "")
              : [];

            return (
              <div className="machine-card" key={item.id}>
                {/* IMAGE */}
                <div className="machine-img-container">
                  <img
                    src={`${UPLOADS.MACHINE_IMAGE}${images[0]}`}
                    alt={item.machine_name}
                  />

                  <span className="heads-badge">{item.NoOfHeads} Heads</span>
                </div>

                {/* BODY */}
                <div className="machine-body">
                  <h4 className="machine-name">{item.machine_name}</h4>

                  {/* PRICE */}
                  <div className="d-flex align-items-center justify-content-between mt-2">
                    <div className="price-block">
                      <span className="currency-symbol">₹</span>
                      <span className="amount">
                        {Number(item.price).toLocaleString("en-IN")}
                      </span>
                    </div>

                    <button className="contact-btn">
                      <i className="bi bi-telephone-fill me-1"></i> Contact
                    </button>
                  </div>

                  {/* BRAND */}
                  <div className="spec-row mt-2">
                    <div className="spec-item">
                      <span className="spec-label">Brand:</span>
                      <span className="spec-value">{item.brand}</span>
                    </div>
                  </div>
                  <div className="location-info">
                    <i className="bi bi-geo-alt-fill"></i> {item.city},{" "}
                    {item.state}
                  </div>
                  <div className="machine-actions mt-3">
                    <button
                      className="action-btn view-action"
                      onClick={() => setViewData(item)}
                      title="View"
                    >
                      <i className="bi bi-eye-fill"></i>
                    </button>

                    <button
                      className="action-btn edit-action"
                      onClick={() =>
                        navigate("/user/add-machine", { state: item })
                      }
                      title="Edit"
                    >
                      <i className="bi bi-pencil-square"></i>
                    </button>

                    <button
                      className="action-btn delete-action"
                      onClick={() => deleteMachine(item.id)}
                      title="Delete"
                    >
                      <i className="bi bi-trash-fill"></i>
                    </button>
                  </div>

                  {/* FOOTER BUTTONS */}
                </div>
              </div>
            );
          })
        ) : (
          <p>No machines listed yet.</p>
        )}
      </div>

      {/* VIEW POPUP */}
      {viewData && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>⚙ Machine Details</h3>

              <button
                className="close-icon-btn"
                onClick={() => setViewData(null)}
              >
                ✕
              </button>
            </div>

            <div className="popup-grid">
              <div>
                <label>Machine</label>
                <p>{viewData.machine_name}</p>
              </div>
              <div>
                <label>Brand</label>
                <p>{viewData.brand}</p>
              </div>
              <div>
                <label>Model</label>
                <p>{viewData.model}</p>
              </div>
              <div>
                <label>Heads</label>
                <p>{viewData.NoOfHeads}</p>
              </div>
              <div>
                <label>Needles</label>
                <p>{viewData.NoOfNeedls}</p>
              </div>
              <div>
                <label>Beam Body</label>
                <p>{viewData.beamBody}</p>
              </div>
              <div>
                <label>Usb Port</label>
                <p>{viewData.usbport}</p>
              </div>
              <div>
                <label>Speed</label>
                <p>{viewData.Maxsewingspeed} RPM</p>
              </div>
              <div>
                <label>Motor</label>
                <p>{viewData.motor}</p>
              </div>
              <div>
                <label>Price</label>
                <p>₹ {Number(viewData.price).toLocaleString("en-IN")}</p>
              </div>
              <div>
                <label>Status</label>
                <p>{viewData.status}</p>
              </div>
              <div>
                <label>City</label>
                <p>{viewData.city}</p>
              </div>
              <div>
                <label>Seller</label>
                <p>
                  {viewData.name} ({viewData.phone})
                </p>
              </div>
            </div>

            <div className="description-box">
              <label>Description</label>
              <p>{viewData.description}</p>
            </div>

            <div className="popup-images">
              {viewData.image &&
                viewData.image
                  .split(",")
                  .filter((img) => img && img.trim() !== "")
                  .map((img, i) => (
                    <img
                      key={i}
                      src={`${UPLOADS.MACHINE_IMAGE}${img}`}
                      alt="machine"
                    />
                  ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
